import type { FetchGradesType } from "../../../../../common-deprecated/types/GradesType";

export const SET_GRADES = "setGrades" as const;

type SetGradesType = { type: typeof SET_GRADES; grades: FetchGradesType };

export const setGrades = (grades: FetchGradesType): SetGradesType => ({
    type: SET_GRADES,
    grades,
});

export type GradesActionType = SetGradesType;
